import React from 'react';
import {
  PieChart, Pie, Tooltip, Cell, Legend, ResponsiveContainer
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const COLORS = [
  '#1976d2', '#ef5350', '#66bb6a',
  '#ffa726', '#ab47bc', '#26c6da', '#ffca28',
];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { value, payload: entry } = payload[0];
  const total = entry.total || 0;
  const percent = total > 0 ? (value / total) * 100 : 0;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">📍 Sucursal: {entry.category}</Typography>
      <Typography variant="body2">💰 Ventas: {formatMoney(value)}</Typography>
      <Typography variant="body2">📊 Porcentaje: {percent.toFixed(1)}%</Typography>
    </Box>
  );
};

const CategorySalesChart = ({ data = [], loading }) => {
  const totalValue = data.reduce((acc, curr) => acc + curr.value, 0);
  const chartData = data.map(item => ({ ...item, total: totalValue }));

  return (
    <Paper elevation={2} sx={{ p: 2, height: 360 }}>
      <Typography variant="subtitle1" gutterBottom>
        Participación en ventas por sucursal
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="category"
                cx="50%"
                cy="50%"
                outerRadius={90}
                label={({ value }) => `${formatMoney(value)}`}
              >
                {chartData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default CategorySalesChart;
